import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from '@/lib/auth/useAuth'

/**
 * Wrapper de rota — redireciona para `/login` quando não há sessão válida.
 *
 * Por que NÃO mostrar nada durante hidratação (em vez de spinner): a fase
 * `isHydrating` é tipicamente <100ms (uma chamada GET /auth/me com token
 * já em cache do MSW). Spinner seria flicker visual desnecessário. Quem
 * quiser pode customizar via prop `fallback`.
 */
export interface RequireAuthProps {
  fallback?: React.ReactNode
  redirectTo?: string
}

export function RequireAuth({
  fallback = null,
  redirectTo = '/login',
}: RequireAuthProps) {
  const { isHydrating, isAuthenticated } = useAuth()

  if (isHydrating) {
    return <>{fallback}</>
  }

  if (!isAuthenticated) {
    // `replace: true` em <Navigate> evita poluir o history com a tentativa
    // bloqueada — botão "voltar" do navegador funciona como esperado.
    return <Navigate to={redirectTo} replace />
  }

  return <Outlet />
}
